ko.bindingHandlers.map = {
    init: (element, valueAccessor, allBindings, viewModel, bindingContext) => {
        let value = valueAccessor();

        ko.mapping.fromJS(value, viewModel);
    }
}